import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

export default function KeyboardDatePickerInput(props) {

  const { label, errors, ...keyboardDatePickerProps } = props;

  return (
    <FormControl fullWidth>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          format="MM/dd/yyyy"
          autoOk
          inputVariant="standard"
          error={!!props.errors}
          helperText={props.errors && props.errors.message}
          label={label}
          KeyboardButtonProps={{
            'aria-label': `enter ${label}`,
          }}
          {...keyboardDatePickerProps}
        />
      </MuiPickersUtilsProvider>
    </FormControl>
  )
}

KeyboardDatePickerInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputRef: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  errors: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/KeyboardDatePickerInput.js